import LegalPage from "@/components/legal/LegalPage";
import { PRIVACY_POLICY, COOKIE_POLICY, TERMS } from "@/data/legalData";

export const PrivacyPolicyPage = () => (
  <LegalPage
    testId="privacy-policy-page"
    subtitle="Защита на личните данни"
    path="/politika-za-poveritelnost"
    {...PRIVACY_POLICY}
  />
);

export const CookiePolicyPage = () => (
  <LegalPage
    testId="cookie-policy-page"
    subtitle="Бисквитки и проследяване"
    path="/biskvitki"
    {...COOKIE_POLICY}
  />
);

export const TermsPage = () => (
  <LegalPage
    testId="terms-page"
    subtitle="Правила за ползване"
    path="/obshti-usloviya"
    {...TERMS}
  />
);
